/* Swift Ink homepage product rails (Best Sellers, New In): quick add into
   the AMP slide cart, a scroll progress line, and mouse drag on desktop. */
(function () {
  if (window.__siHomeCards) return;
  window.__siHomeCards = true;

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function openCart() {
    if (typeof SLIDECART_UPDATE === 'function') SLIDECART_UPDATE();
    if (typeof SLIDECART_OPEN === 'function') SLIDECART_OPEN();
  }

  function cartAddUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-si-add]');
    /* The slide cart's suggestion buttons also use data-si-add and are
       handled by si-cart.js; adding here too put 2 in the cart. */
    if (!btn || btn.closest('#SiCart') || btn.disabled || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var original = btn.innerHTML;
    btn.classList.add('is-loading');
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-si-add'), 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = TICK + '<span>Added</span>';
        setTimeout(openCart, 150);
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.innerHTML = original;
        }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.innerHTML = '<span>Sold out</span>';
        setTimeout(function () { btn.innerHTML = original; }, 2200);
      });
  });

  function initRail(rail) {
    if (rail.__siRail) return;
    rail.__siRail = true;

    var bar = rail.parentNode.querySelector('.si-rail-bar');
    var fill = bar && bar.querySelector('span');
    function update() {
      if (!fill) return;
      var max = rail.scrollWidth - rail.clientWidth;
      bar.hidden = max <= 1;
      if (max <= 1) return;
      var w = Math.max(12, Math.min(100, (rail.clientWidth / rail.scrollWidth) * 100));
      fill.style.width = w + '%';
      fill.style.left = (rail.scrollLeft / max) * (100 - w) + '%';
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Mouse drag (desktop). A drag doesn't count as a click on a card. */
    var down = false;
    var moved = false;
    var startX = 0;
    var startLeft = 0;
    rail.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.pageX;
      startLeft = rail.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
    });
    rail.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        rail.classList.add('is-dragging');
      }
      if (moved) {
        e.preventDefault();
        rail.scrollLeft = startLeft - dx;
      }
    });
    rail.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-si-rail]').forEach(initRail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
